import { Route, Routes } from 'react-router'
import Layout from './components/Layout'
import Home from './pages/Home'
import Beoordeling from './pages/Beoordeling'
import OverOns from './pages/OverOns'
import Contact from './pages/Contact'
import Bedankt from './pages/Bedankt'
import Betaal from './pages/Betaal'
import Privacy from './pages/Privacy'
import Voorwaarden from './pages/Voorwaarden'
import NietGevonden from './pages/NietGevonden'

/*
 * De paden staan ook in routes.ts, waar het prerender-script ze uitleest. Ze hier
 * herhalen is niet fraai, maar het alternatief — componenten in de routetabel zetten —
 * trekt elke pagina de serverbundel in en daarmee ook het prerender-script.
 * routes.test.ts bewaakt dat de twee lijsten gelijk blijven.
 */
export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/beoordeling" element={<Beoordeling />} />
        <Route path="/over-ons" element={<OverOns />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/bedankt" element={<Bedankt />} />
        {/*
          Twee paden voor één pagina: /betaal/:token is de echte route, /betaal
          is de schil die geprerenderd wordt en waar staticwebapp.config.json
          alles onder /betaal/ naartoe stuurt.
        */}
        <Route path="/betaal" element={<Betaal />} />
        <Route path="/betaal/:token" element={<Betaal />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/voorwaarden" element={<Voorwaarden />} />
        <Route path="*" element={<NietGevonden />} />
      </Route>
    </Routes>
  )
}
